var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6963_63737)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0195 30.0218C12.0195 26.6326 19.7302 23.8828 29.2451 23.8828C38.7573 23.8828 46.468 26.6327 46.468 30.0218V35.6642C46.468 39.0533 38.7573 41.8031 29.2451 41.8031C19.7302 41.8031 12.0195 39.0532 12.0195 35.6642C12.0195 33.7834 12.0195 31.9025 12.0195 30.0218Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2451 23.8828C38.7573 23.8828 46.468 26.6327 46.468 30.0218C46.468 33.4135 38.7573 36.1608 29.2451 36.1608C19.7302 36.1608 12.0195 33.4136 12.0195 30.0218C12.0194 26.6326 19.7302 23.8828 29.2451 23.8828Z",
    fill: "#FECD3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2435 26.75C36.8116 26.75 42.9453 28.2161 42.9453 30.0203C42.9453 31.8271 36.8116 33.2905 29.2435 33.2905C21.6754 33.2905 15.5391 31.827 15.5391 30.0203C15.5391 28.2161 21.6754 26.75 29.2435 26.75Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5259 38.3756L21.9973 38.3782V41.2364C21.4928 41.1545 21.0041 41.062 20.5259 40.9617V38.3756ZM41.8115 36.862V39.8655C42.3424 39.662 42.8338 39.4482 43.2855 39.2236V36.8594L41.8115 36.862ZM25.846 41.6855C26.332 41.7224 26.8234 41.7489 27.32 41.7674V39.036L25.846 39.0387V41.6855ZM15.2031 39.2236C15.6549 39.4482 16.1462 39.662 16.6771 39.8655V36.8594L15.2031 36.862V39.2236ZM31.1687 41.7674C31.6679 41.7489 32.1566 41.7198 32.64 41.6855V39.0387L31.1687 39.036V41.7674ZM36.4914 41.2364C36.9959 41.1545 37.4873 41.062 37.9628 40.9617V38.3782L36.4914 38.3756V41.2364Z",
    fill: "#C85929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11725 36.8438V38.6717H6.94261V39.9766H5.11725V41.8046H3.81237V39.9766H1.98438V38.6717H3.81237V36.8438H5.11725Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5092 16.8203V18.6482H40.3371V19.9506H38.5092V21.7785H37.2042V19.9506H35.3789V18.6482H37.2042V16.8203H38.5092Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99225 5.96875V7.79675H7.81761V9.09899H5.99225V10.927H4.68728V9.09899H2.85938V7.79675H4.68728V5.96875H5.99225Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.374359 26.8289C-1.3215 23.8915 3.98276 17.6548 12.2217 12.9C20.4608 8.14255 28.5122 6.66857 30.2081 9.60328C31.1485 11.2331 32.0888 12.8603 33.0293 14.4875C34.7251 17.4249 29.4209 23.6616 21.1819 28.4164C12.9429 33.1739 4.8914 34.6505 3.19555 31.7131C2.25512 30.086 1.31479 28.4561 0.374359 26.8289Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2217 12.9C20.4608 8.14255 28.5122 6.66857 30.2081 9.60328C31.9039 12.5407 26.5997 18.7774 18.3607 23.5322C10.1244 28.2897 2.07021 29.7636 0.374359 26.8288C-1.3215 23.8915 3.98276 17.6548 12.2217 12.9Z",
    fill: "#FECD3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6569 15.3866C20.2106 11.6039 26.2571 9.80501 27.1605 11.3688C28.0639 12.9326 23.4808 17.2674 16.9272 21.0528C10.3734 24.8355 4.32953 26.6344 3.42616 25.0706C2.52279 23.5068 7.10313 19.1719 13.6569 15.3866Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1314 26.9861L19.4971 29.3503C19.056 29.5828 18.6175 29.8046 18.179 30.0159L16.8556 27.7231L18.1314 26.9861ZM6.55078 31.1597L7.7316 33.2042C8.23347 33.1752 8.76712 33.1144 9.3271 33.0246L7.82669 30.4227L6.55078 31.1597ZM11.9158 29.8099L13.2101 32.0499C13.6724 31.8994 14.1426 31.7329 14.6207 31.5533L13.1916 29.0755L11.9158 29.8099ZM21.465 25.0604L22.8307 27.4245C23.2508 27.1604 23.6628 26.891 24.0643 26.6189L22.7409 24.3286L21.465 25.0604ZM30.869 17.1172L29.5931 17.8568L31.0961 20.4561C31.4528 20.0177 31.7724 19.5844 32.0497 19.1643L30.869 17.1172ZM25.7444 21.8271L27.1735 24.3049C27.5697 23.9826 27.9475 23.6578 28.3094 23.3328L27.0177 21.0954L25.7444 21.8271Z",
    fill: "#C85929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6963_63737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.4991,
    height: 46.4991,
    fill: "white",
    transform: "translate(0.0117188 0.632812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/pointsIcon.65d8ff9600bcbfc56f00f2103a9faee9.svg";
export { ForwardRef as ReactComponent };